module.exports = __webpack_public_path__ + "img/icons BFr_9.1e2f2000.svg";